module.exports = "<div ui-view\n  ng-cloak>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/railway/templates/index.html
// module id = 1515
// module chunks = 0